import { render, staticRenderFns } from "./ed-calls.component.vue?vue&type=template&id=4e2943b4&scoped=true&"
import script from "./ed-calls.component.ts?vue&type=script&lang=ts&"
export * from "./ed-calls.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-calls.view.scss?vue&type=style&index=0&id=4e2943b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2943b4",
  null
  
)

export default component.exports